import { FoodBank } from '@mui/icons-material';
import Reeact from 'react';
import {Box, Card, Grid,CardContent, CardMedia, Typography} from '@mui/material';
import './Footer.css';

const Footer = () => {
    return (
      <div>
      <div style={{ marginTop: "40px", padding: "20px 0", textAlign: "center", backgroundColor: "#4cadd4" }}>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={4} style={{ textAlign: "center", alignContent:"center" }}>
        <img 
          src="/assets/images/siren.png" 
          alt="Red emergency siren light symbolizing urgent medical assistance, set against a plain background, conveying a sense of urgency and support" 
          width="60" 
        />
        <h3>24/7 Emergency Service</h3>
        <button style={{ background: "#730047", color: "white", border: "none", padding: "8px 12px", borderRadius: "4px" }}>
          📞 +91-9345108108
        </button>
        </Grid>
        <Grid item xs={12} sm={4} style={{ textAlign: "center", alignContent:"center" }}>
        <a href="https://bannumedicalcenter.com/" style={{textDecoration:"none" , color:"black"}}>
          <img 
          src="/assets/images/" 
          alt="- Renova Cancer Hospital, Warangal" 
          width="200" 
          />
        </a>
        <a href="h"  style={{textDecoration:"none" , color:"black"}}>
          <img 
          src="/assets/images/" 
          alt="Dhanvi Clinic  " 
          width="200" 
          />
          <h3>Book an Appointment</h3>
        </a>
        </Grid>
        <Grid item xs={12} sm={4} style={{ textAlign: "center" , alignContent:"center"}}>
        <a style={{textDecoration:"none" , color:"black"}} href='https://www.youtube.com/@tarunreddy110690'>
          <img 
          src="/assets/images/youtubeicon.png" 
          alt="YouTube play button icon in red and white, representing a link to Dr Tarun Reddys YouTube channel for educational and awareness videos" 
          width="80" 
          />
          <h3>For More Awareness</h3>
        </a>
        <button style={{ background: "#ff0000", color: "white", border: "none", padding: "8px 12px", borderRadius: "4px" }}>
          <a style={{textDecoration:"none" , color:"white"}} href='https://www.youtube.com/@tarunreddy110690'>SUBSCRIBE TO MY YOUTUBE CHANNEL</a>
        </button>
        </Grid>
      </Grid>

      </div>

      <div style={{ marginTop: "40px", textAlign: "center", backgroundColor: "#730047", color:"white"  }}>

      <Grid container style={{marginTop : "20px", color:"white" , justifyContent:"center"}}>
        <Grid item xs={12} sm={4} style={{ textAlign: "center", alignContent:"center"}}>
        <img 
          src="/assets/images/tarunlogo.png" 
          alt="Dr Tarun Reddy logo featuring stylized initials TR in purple and gold, with text Dr Tarun Reddy Best Surgical Oncologist, conveying professionalism and trust in a clinical setting" 
          width="300" 
          height="150" 
          style={{padding:"20px"}}
        />
        </Grid>
        <Grid item xs={12} sm={4} style={{ textAlign: "center", alignContent:"center" , color:"white"}}>
         <h3>Quick Links</h3>
         <Typography><a style={{textDecoration:"none" , color:"white"}} href='https://www.youtube.com/@tarunreddy110690'>About Dr. Tarun Reddy</a></Typography>
         <Typography><a style={{textDecoration:"none" , color:"white"}} href='https://www.youtube.com/@tarunreddy110690'>Specialities</a></Typography>
         <Typography><a style={{textDecoration:"none" , color:"white"}} href='https://www.youtube.com/@tarunreddy110690'>Book An Appointment</a></Typography>
         </Grid>
        <Grid item xs={12} sm={4} style={{ textAlign: "center" , alignContent:"center"}}>
        <h3>Location</h3>
        <iframe
          width="100%"
          height="200"
          frameBorder="0"
          style={{ border: 0 }}
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCR6gh7rpy5_t7Xw8OR_-X43BV0MDwAHJM&q=Bannu Medical Centre"
          allowFullScreen
          title="Google Map showing location of Dr Tarun Reddy Best Surgical Oncologist clinic in Warangal"
        ></iframe>
        </Grid>
      </Grid>

      </div>
      </div>
    );
}

export default Footer;